export function transformOfferText({
    offerText,
    additionalText,
}: {
    offerText?: string;
    additionalText?: string;
}): string {
    if (offerText === additionalText || !additionalText) {
        return offerText || '';
    }

    return [offerText, additionalText].filter(Boolean).join(', ');
}
